import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    linkGroup: {
        textDecoration: 'none',
    },
    button: {
        color: 'rgb(24, 116, 185)',
        fontSize: 17,
        background: 'none',
        border: 'none',
        boxShadow: 'none',
    },
    buttonActive: {
        boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)',
        backgroundColor: '#d5d5d5',
    }
})

export default useStyles